import React from 'react';

import BankAccountComponent from '../../../BankAccount';

export default function BankAccount({ lenderId, lender, refetch }) {
  return (
    <BankAccountComponent
      lenderId={lenderId}
      lender={lender}
      refetch={refetch}
      isLenderPage
    />
  );
}
